function AppFeatures() {

    const features = [
        { icon: "⚡", title: "Electricity Usage monitoring", desc: "Log and track electricity usage as it happens. See which appliances and\n" +
                "                        time-of-day patterns drain your units fastest." },
        { icon: "₦", title: "Cost estimator", desc: "Instantly convert units to naira with up-to-date IKEDC and EKEDC tariff\n" +
                "                        rates. No more end-of-month surprises." },
        {icon: "📊", title: "Usage history", desc: "Review daily, weekly, and monthly breakdowns. Spot trends and understand\n" +
                "                        exactly why your bill went up." },
        {icon: "💡", title: "Smart suggestions", desc: "Get actionable tips tailored to your usage profile — practical ways to\n" +
                "                        cut costs without disrupting your routine." },
        {icon: "📤", title: "Shareable reports", desc: "Generate a clean usage summary and share it with family, tenants, or on\n" +
                "                        social media in one tap." },
    ];

    return (
        <section id="features" className="features">
            <div className="sl">Features</div>

            <div className="st">
                Everything you need<br />
                inside the app
            </div>

            <div className="features-grid">
                {features.map((f, i) => (
                    <div className="fc" key={i}>
                        <div className="fi">{f.icon}</div>
                        <h3>{f.title}</h3>
                        <p>{f.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
export default AppFeatures;
